import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DefaultScheduleService } from 'app/core/services/default-schedule.service';
import { RefreshDefaultschedulelineService } from 'app/core/services/refresh-defaultscheduleline/refresh-defaultscheduleline.service';

@Component({
  selector: 'dialog-add-defaultschedule',
  templateUrl: './dialog-add-defaultschedule.component.html',
  styleUrls: ['./dialog-add-defaultschedule.component.scss']
})
export class DialogAddDefaultscheduleComponent implements OnInit {
  isLoading: boolean = false;
  scheduleGroup: FormGroup;
  weekdays: { value: number, name: string }[] = [
    { value: 0, name: 'Sunday' },
    { value: 1, name: 'Monday' },
    { value: 2, name: 'Tuesday' },
    { value: 3, name: 'Wednesday' },
    { value: 4, name: 'Thursday' },
    { value: 5, name: 'Friday' },
    { value: 6, name: 'Saturday' }
  ];

  constructor(public dialogRef: MatDialogRef<DialogAddDefaultscheduleComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private defaultScheduleService: DefaultScheduleService, private refreshDefaultschedulelineService: RefreshDefaultschedulelineService) {
    this.scheduleGroup = this.fb.group({
      id: [0],
      scheduleId: [this.data?.scheduleId || 0],
      weekDay: [null],
      isRestDay: [false],
      rampTime1: [null],
      rampTime2: [null],
      rampTime3: [null],
      rampTime4: [null],
      rampTime5: [null],
      rampTime6: [null],
      RAMP_isAddMissingTime: [true],
      RAMP_isComputeRestDay: [true],
      RAMP_isComputeHoliday: [true],
      RAMP_isAdjustOT: [true],
      RAMP_isComputeNightDiff: [false]
    });
  }

  ngOnInit(): void {
    if (this.data?.selectedScale?.RAMP_Employee_ScheduleLine_ID > 0) {
      const selectedElement = this.data.selectedScale;
      console.log(selectedElement);
      this.scheduleGroup.patchValue({
        id: selectedElement.RAMP_Employee_ScheduleLine_ID || 0,
        scaleId: selectedElement.RAMP_Employee_Schedule_ID || 0,
        weekDay: selectedElement.Weekday || 0,
        isRestDay: selectedElement.RAMP_isRestDay || false,
        rampTime1: this.formatTime(selectedElement.RAMP_Time1),
        rampTime2: this.formatTime(selectedElement.RAMP_Time2),
        rampTime3: this.formatTime(selectedElement.RAMP_Time3),
        rampTime4: this.formatTime(selectedElement.RAMP_Time4),
        rampTime5: this.formatTime(selectedElement.RAMP_Time5),
        rampTime6: this.formatTime(selectedElement.RAMP_Time6),
        RAMP_isAddMissingTime: selectedElement.RAMP_isAddMissingTime || true,
        RAMP_isComputeRestDay: selectedElement.RAMP_isComputeRestDay || true,
        RAMP_isComputeHoliday: selectedElement.RAMP_isComputeHoliday || true,
        RAMP_isAdjustOT: selectedElement.RAMP_isAdjustOT || true,
        RAMP_isComputeNightDiff: selectedElement.RAMP_isComputeNightDiff || false
      });
    }
  }

  formatTime(time: string): string {
    if (time) {
      const timeParts = time.split(' ')[1]; // Extract the time part
      const [hours, minutes] = timeParts.split(':');
      const period = +hours >= 12 ? 'PM' : 'AM';
      const formattedHours = (+hours % 12) || 12; // Convert to 12-hour format

      return `${formattedHours}:${minutes} ${period}`;
    }
    return '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    this.isLoading = true;

    if (this.scheduleGroup.invalid) {
      Object.keys(this.scheduleGroup.controls).forEach((controlName) => {
        this.scheduleGroup.get(controlName)?.markAsTouched();
        this.isLoading = false;
      });
      return;
    }
    if (this.scheduleGroup.valid) {
      this.defaultScheduleService.createUpdateScheduleLine(this.scheduleGroup.value).subscribe({
        next: res => {
          this.refreshDefaultschedulelineService.emitRefresh2(this.scheduleGroup.value.id);
          Promise.resolve().then(() => {
            this.isLoading = false;
            this.dialogRef.close();
          });
        },
        error: err => {
          console.log(err);
          this.isLoading = false;
        }
      })
    }
  }
}